// removed by extract-text-webpack-plugin
module.exports = {"timeline-container":"timeline-container","col-xs-2":"col-xs-2","col-xs-10":"col-xs-10","timeline":"timeline","active":"active","add-event":"add-event","event-year":"event-year","eventTypeToggle":"eventTypeToggle","icon-angle-right":"icon-angle-right","icon-angle-down":"icon-angle-down","eventColumn":"eventColumn","timeline-title":"timeline-title","on-boarding":"on-boarding","col-sm-2":"col-sm-2","col-sm-10":"col-sm-10","col-xs-1":"col-xs-1"};


//////////////////
// WEBPACK FOOTER
// ./src/template/Docks/StudentInfo/Timeline/Timeline.scss
// module id = qjB7
// module chunks = 0